export const EDITABLE_FIELDS = [
  'city',
  'country',
  'netSuiteCustomerId',
  'nsCustomerId',
  'region',
  'siteName',
]
